import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import type {
    PsHttp,
    PatSnapSuccessResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { LocApi } from './loc-api'
import type { PsHttpChannel } from '@patsnap/tahiti-core';
import type { ILocTreeItem } from '../apis/types/loc'
import { getDesignFtoApiUrlPrefix } from '../constants/design-fto';

@injectable()
export class LocApiImpl extends PsHttpService implements LocApi {
    _coreTelecomApiUrlPrefix = '';

    constructor(httpClient: PsHttp, httpChannelClient: PsHttpChannel) {
        super(httpClient, httpChannelClient);
        this.init();
    }

    async init() {
        this._coreTelecomApiUrlPrefix = await getDesignFtoApiUrlPrefix();
    }

    get options() {
        return {
            baseURL: this._coreTelecomApiUrlPrefix,
            headers: {
                'Content-Type': 'application/json',
            },
        };
    }

    /**
     * 获取LOC分类树节点数据
     * @param code - LOC分类代码，为空则获取根节点
     */
    async getLOCItemsData(code?: string): Promise<ILocTreeItem[]> {
        const result = await this.get<PatSnapSuccessResponseData<ILocTreeItem[]>>({
            url: '/workflow/classification/helper-section-subclass',
            cache: true,
            params: {
                type: 'loc',
                code,
            },
        });
        return result?.data as unknown as ILocTreeItem[];
    }

    /**
     * 根据关键词搜索LOC分类树
     * @param keyword - 搜索关键词
     */
    async getLOCTreeByKeyword(keyword: string): Promise<{
        query_results: Array<{
            cls_tree: ILocTreeItem;
        }>;
    }> {
        const result = await this.get<PatSnapSuccessResponseData<{
            query_results: Array<{
                cls_tree: ILocTreeItem;
            }>;
        }>>({
            url: '/workflow/classification/helper-search',
            params: {
                type: 'loc',
                keyword,
            },
        });
        return result?.data as unknown as {
            query_results: Array<{
                cls_tree: ILocTreeItem;
            }>;
        };
    }

    /**
     * 根据图片预测LOC分类
     * @param params - 预测参数
     * @param signal - 终止信号
     */
    async predictLOC(params: { url: string }, signal?: AbortSignal): Promise<ILocTreeItem[]> {
        const result = await this.post<PatSnapSuccessResponseData<ILocTreeItem[]>>({
            url: '/workflow/loc-predict',
            data: params,
            signal,
        });
        return (result?.data || []) as unknown as ILocTreeItem[];
    }
}
